const Theme = {
    borders: {},
    borderWidths: ['none', '1px', '2px'],
    fontSizes: ['0.9rem', '1rem', '1.1rem', '1.25rem', '1.4rem'],
    fonts: {
        arial: 'Arial',
        comicSans: 'Comic Sans'
    },
    fontWeights: {
        light: 200,
        normal: 400,
        heavy: 700,
        black: 700
    },
    letterSpacings: [],
    space: [0, 4, 8, 16, 32, 64],
    sizes: [100, 200, 400, 620, 800, 1200],
    radii: ['2px', '4px', '6px', '12px'],
    colors: {
        eggshell: '#f4f1de',
        terracotta: '#e07a5f',
        independence: '#3d405b',
        green: '#81b29a',
        champagne: '#f2cc8f',
        white: '#fff',
        black: '#000',
        link: '#3f51b5',
        grey: [
            'rgb(50,50,50)',
            'rgb(100,100,100)',
            'rgb(150,150,150)',
            'rgb(200,200,200)',
        ]
    },
    shadows: [
        'none',
        '0 0 2px rgba(0,0,0,0.35)',
        '0 2px 6px rgba(0,0,0,0.5)'
    ],
    zIndices: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
}

export default Theme